import React from 'react';
import { Icon, Statistic } from 'semantic-ui-react';

const StatCard = ({ color, icon, count, text, ...props }) => (
	<Statistic color={ color } size='mini' { ...props }>
		<Statistic.Value>
			<Icon name={ icon } />
			{' '}
			<span>{ count }</span>
		</Statistic.Value>
		<Statistic.Label>
			{ text }
		</Statistic.Label>
	</Statistic>
)

export default StatCard;
